/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigLeft = [
  "svg",
  defaultAttributes,
  [["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z" }]]
];

export { ArrowBigLeft as default };
//# sourceMappingURL=arrow-big-left.js.map
